import { HTTP_STATUS } from '../config/api';

// HTTP Client utility for API calls
class HttpClient {
  async request(url, options = {}) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      },
      ...options
    };

    // Add authorization header if token exists
    const token = sessionStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(url, config);
      const data = await response.json();

      if (!response.ok) {
        if (response.status === 401) {
          window.dispatchEvent(new Event('auth:session-expired'));
        }
        throw new ApiError(data.message || 'Request failed', response.status, data);
      }

      return data;
    } catch (error) {
      if (error instanceof ApiError) {
        throw error;
      }

      // Network or other errors
      throw new ApiError('Network error occurred', 0, { originalError: error.message });
    }
  }

  get(url, options = {}) {
    return this.request(url, { ...options, method: 'GET' });
  }

  post(url, data, options = {}) {
    return this.request(url, {
      ...options,
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  put(url, data, options = {}) {
    return this.request(url, {
      ...options,
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  delete(url, options = {}) {
    return this.request(url, { ...options, method: 'DELETE' });
  }
}

// Custom error class for API errors
export class ApiError extends Error {
  constructor(message, status, data = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }

  isValidationError() {
    return this.status === HTTP_STATUS.BAD_REQUEST && this.data.errors;
  }

  isAuthError() {
    return this.status === HTTP_STATUS.UNAUTHORIZED;
  }

  isServerError() {
    return this.status >= HTTP_STATUS.INTERNAL_SERVER_ERROR;
  }
}

// Create a singleton instance
const httpClient = new HttpClient();
export default httpClient;